import styled, { keyframes } from "styled-components";
import { darken } from "polished";
import { TABLE_BORDER } from "../settings/colors";

const pulse = keyframes`
  0%{
      background-position: -468px 0
  }
  100%{
      background-position: 468px 0
  }
`;

const Placeholder = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${pulse};
  animation-timing-function: linear;
  background: ${TABLE_BORDER};
  background: linear-gradient(
    to right,
    ${TABLE_BORDER} 8%,
    ${darken(0.075, TABLE_BORDER)} 18%,
    ${TABLE_BORDER} 33%
  );
  background-size: 800px 104px;
  position: relative;
  height: 17px;
  width: 100%;
`;

export default Placeholder;



// WEBPACK FOOTER //
// ./src/components/Placeholder.js